/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart-disabled',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your Cart is empty! <br/>Add your favorite items to your cart.<br/><br/> <a href="/collections" class="cta button">Shop Now</a>',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        */
       document.addEventListener('click', (event) => {
           if (event.target.matches(this.defaults.addToCart)) {
               event.preventDefault();
               let item = event.target;
               let form = item.parentNode;
               while ('form' !== form.tagName.toLowerCase()) {
                   form = form.parentNode;
               }
               const formID = form.getAttribute('id');
               this.addItemToCart(formID);
           }
       }, false);

        /*
        if (this.addToCart) { 
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }
        */

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback)})
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, {hash: true});

        if ( formData.selling_plan && formData.selling_plan == 'required' ) {
            // Add error message
            if ( form.querySelector('.rc_error-msg') === null ) {
                form.querySelector(`[data-plans-container]`).innerHTML += `
                    <p class="rc_error-msg">* Please select a frequency.</p>
                `
            }
            return
        }

        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => this.addItemToCartHandler(product))
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    upgradeItemSubscription(line, new_quantity, variant_id, selling_plan) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => {
                // this.fetchCart()

                window.fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: variant_id,
                        quantity: new_quantity,
                        selling_plan: selling_plan,
                        line: line
                    }),
                })
                    .then((response) => response.json())
                    .then((product) => this.addItemToCartHandler(product))
                    .catch((error) => {
                        this.ajaxRequestFail();
                        throw new Error(error);
                    });
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ? 
              `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` : 
              `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {
        this.clearCartDrawer();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            let isSubscription = null;
            let subscriptionBtnLabel = `Upgrade to Subscribe & Save`;
            let subscriptionPlan = undefined;
            let subscriptionDropdown = ``;

            if ( item.selling_plan_allocation ) {
                isSubscription = true;

                item.selling_plan_groups.forEach(selling_plan_group => {
                    if ( selling_plan_group.app_id == '294517' ) {
                        subscriptionDropdown += `<select class="js-go-cart-item__delivery" data-variant-id="${item.variant_id}">`;
                        selling_plan_group.selling_plans.forEach(plan => {
                            subscriptionDropdown += `<option value="${plan.id}" ${plan.id == item.selling_plan_allocation.selling_plan.id? `selected` : ``}>${plan.name}</option>`;
                        })
                        subscriptionDropdown += `</select>`;
                    }
                })
            } else { 
                if (item.selling_plan_groups.length) {
                    isSubscription = false;
                    item.selling_plan_groups.forEach(selling_plan_group => {
                        if ( selling_plan_group.app_id == '294517' ) {
                            const selling_plan = selling_plan_group.selling_plans[0];
                            subscriptionPlan = selling_plan.id;
                            if ( selling_plan.price_adjustments[0].value_type == 'percentage' && selling_plan.price_adjustments[0].value != 0 ) {
                                subscriptionBtnLabel += ` ${selling_plan.price_adjustments[0].value}%`;
                            }
                        }
                    })
                }
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                  <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                  <div class="go-cart-item__info">
                    ${item.product_tags.includes(this.hiddenItemTag) ? 
                    `<p class="go-cart-item__title h5 color-sun">${item.product_title}</p>` : 
                    `<a href="${item.url}" class="go-cart-item__title h5 color-sun">${item.product_title}</a>`}
                    <div class="go-cart-item__variant body1">${itemVariant}</div>
                    ${item.selling_plan_allocation ? 
                        `<div class="go-cart-item__delivery body1" style="display: none">${item.selling_plan_allocation.selling_plan.name}</div>
                        <div class="go-cart-item__delivery body1">${subscriptionDropdown}</div>
                        ` 
                        : 
                        ``
                    }
                    <div class="go-cart-price-qty body1">
                      <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                      <div class="go-cart-item__quantity">
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                        <input class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${item.quantity}" disabled>
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                      </div>
                    </div>
                    ${isSubscription == false? `<span class="go-cart-item__upgrade js-go-cart-upgrade-item" data-variant-id="${item.variant_id}" data-plan-id="${subscriptionPlan}">${subscriptionBtnLabel}</span>` : ``}
                  </div>
                </div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}"><i class="icon-remove cart-remove"></i></a>
              </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        });
        // Update Free Shipping Bar
        const freeShippingBar = document.querySelector('.free-shipping-bar progress');
        if ( freeShippingBar !== undefined ) {
            freeShippingBar.setAttribute('value', cart.total_price)
        }
        const freeShippingMsg = document.querySelector('.free-shipping-bar .free-shipping-message');
        if ( freeShippingMsg !== undefined ) {
            if ( cart.items.length && freeShippingBar !== undefined ) { 
                const freeShippingThreshold = parseInt(freeShippingBar.getAttribute('max'))
                if ( cart.total_price < freeShippingThreshold ) {
                    freeShippingMsg.innerHTML = `You’re only ${formatMoney((freeShippingThreshold - cart.total_price), this.moneyFormat)} away from free domestic shipping.`;
                } else {
                    freeShippingMsg.innerHTML = `<span>You’ve got FREE DOMESTIC SHIPPING.</span>`;
                }
            } else {
                freeShippingMsg.innerHTML = 'Add items to your cart to receive free domestic shipping.';
            }
        }

        // Update SubTotal
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');

        // Add actions
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
        const upgradeItems = document.querySelectorAll('.js-go-cart-upgrade-item');
        upgradeItems.forEach((item) => {
            item.addEventListener('click', () => {
                const variant_id = item.getAttribute('data-variant-id');
                const plan_id = item.getAttribute('data-plan-id');
                const line = item.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value);
                this.upgradeItemSubscription(line, quantity, variant_id, plan_id);

                GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode);
            });
        });
        const upgradeSubscribeOptions = document.querySelectorAll('.js-go-cart-item__delivery');
        upgradeSubscribeOptions.forEach((item) => {
            item.addEventListener('change', () => {
                const variant_id = item.getAttribute('data-variant-id');
                // const plan_id = item.options[item.selectedIndex].value;
                const plan_id = item.value;
                const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.parentNode.querySelector(this.itemQuantity).value);
                this.upgradeItemSubscription(line, quantity, variant_id, plan_id);

                // GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode);
            });
        });
    }

    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h3">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
        // Update Free Shipping Bar
        const freeShippingMsg = document.querySelector('.free-shipping-bar .free-shipping-message');
        if ( freeShippingMsg !== undefined ) {
            freeShippingMsg.innerHTML = 'Add items to your cart to receive free domestic shipping.';
        }
        const freeShippingBar = document.querySelector('.free-shipping-bar progress');
        if ( freeShippingBar !== undefined ) {
            freeShippingBar.setAttribute('value', 0)
        }
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

}

//export default GoCart;

